module.exports = __webpack_public_path__ + "static/media/board_game.bfc994f4.jpg";